export default __webpack_public_path__ + "static/DSC_0088-d3ebad7980276cadac7d7aee5ebea8b2.jpg";